import PosterFrameHandler from "./../PosterFrameHandler.js";

export default class ListEventHandler
{
    /**
     * @returns {ListEventHandler}
     */
    static make() {
        return new this;
    }
    /**
     * @returns this
     */
    addPosterFrames(frameImagePreloader) {
        // Select all images except the product detail image since it's handled separately to make testing easier
        let $images = jQuery(document).find('.product-thumb-wrap a img').not('body.single-product .woocommerce-product-gallery__image a img.wp-post-image');
        if (!$images.length) {
            return this;
        }
        let posterFrameHandler = new PosterFrameHandler({
            images : $images,
            frameImagePreloader : frameImagePreloader,
            frameShadowOffset : 0,
            framePadding : 0,
            onclickSelectors : [],
            //hiddenSelectorToShowAfterLoad: '.product-thumb-wrap'
        });
        posterFrameHandler.addFrames();
        return this;
    }
}
